module.exports = __webpack_public_path__ + "img/jamaica.29aecbbf.svg";